/*
 * @Author: caiqin.xie
 * @since: 2023-06-21 10:59:34
 * @lastTime: 2023-11-07 09:53:48
 * @LastEditors: caiqin.xie
 * @message: 维修价格
 * @url: www.picoxr.com/cn/support/maintenance-price
 */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Search from "./components/Search";
import SparePartsPrice from './components/SparePartsPrice'
import LaborServiceFee from "./components/LaborServiceFee";
import Notes from "./components/Notes";
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'
import classNames from "classnames";

interface IList{
  [key:string]: any
  paramBOs: Record<string, string>[];
}

const MaintenancePrice = (props: any) => {
  const {ctry, words, data} = props.data
  const [priceList, setPriceList] = useState<IList[]>(data?.maintenancePrices || []) // 维修价格
  const [serviecFeeList, setServiecFeeList] = useState<IList[]>(data?.lobarCosts || []) // 劳务费
  const [notes, setNotes] = useState<string>(data?.notes || "") // Notes
  const [maintenanceDesc, setMaintenanceDesc] = useState<string>(data?.maintenanceDescription || "") // 维修说明
  const [categoryList, setCategoryList] = useState<Record<string, string>[]>(data?.bContentTypes || []) // 产品分类
  const [productList, setProductList] = useState<Record<string, string>[]>(data?.bProducts || []) // 产品列表
  const [defaultProductId, setDefaultProductId] = useState<string>(data?.id ||'') // 初始化产品id/分类改变时当前分类下首个产品id

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/maintenance-price`} />
      ))
    )
  }

  // 根据产品切换维修价格、劳务费
  const getMaintenanceData = (productId: string) => {
    request.post(`${DOMAIN_API}/o/product/getMaintenance`, {
      id: productId,
      stationCode: ctry
    })
    .then(res => {
      const {maintenancePrices, lobarCosts, notes, maintenanceDescription} = res.data
      setPriceList(maintenancePrices)
      setServiecFeeList(lobarCosts)
      setNotes(notes)
      setMaintenanceDesc(maintenanceDescription)
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 切换分类，产品列表改变
  const categoryChange = (categoryId: string) => {
    request.post(`${DOMAIN_API}/o/product/getProduct`, {
      contentTypeId: categoryId,
      stationCode: ctry
    })
    .then(res => {
      setProductList(res.data.productVos)
      setDefaultProductId(res.data?.productVos[0]?.id)
      getMaintenanceData(res.data?.productVos[0]?.id)
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 渲染html
  const creatHtml = () => {
    return {__html: maintenanceDesc}
  }

  return (
    <div>
      <Helmet>
        <title>{words.support_maintenance_price_seo_title}</title>
        <meta name="description" content={words.support_maintenance_price_seo_description} />
        <meta name="keywords" content={words.support_maintenance_price_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/maintenance-price`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['maintenance-wrap']}>
        <div className={styles['maintenance-content-wrap']}>
          <h1 className={styles['maintenance-title']}>
            {words?.support_maintenance_price_title}
            {/* Maintenance Price Query */}
          </h1>
          <div className={styles['maintenance-content']}>
            {/* 搜索 */}
            <Search
              ctry={ctry}
              words={words}
              categoryList={categoryList}
              productList={productList}
              categoryChange={categoryChange}
              productChange={getMaintenanceData}
              defaultProductId={defaultProductId} />

            {/* 内容 */}
            <section className={styles["maintenance-section"]}>
              {/* 维修价格 */}
              <SparePartsPrice ctry={ctry} words={words} priceList={priceList} />

              {/* 维修说明 */}
              {maintenanceDesc && maintenanceDesc !== '' && <div className={classNames(styles['maintenance-tips'], 'editor-wrap')} dangerouslySetInnerHTML={creatHtml()}></div>}

              {/* 劳务费 */}
              <LaborServiceFee ctry={ctry} words={words} serviecFeeList={serviecFeeList} />
            </section>

            <Notes ctry={ctry} words={words} notes={notes} />

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/product/getMaintenance`, {
      stationCode: ctry
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

MaintenancePrice.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default MaintenancePrice;
